import React, { useEffect, useState } from 'react'
import { CustomCheckbox, CustomDataTableHeader, CustomModal } from '../../../../../components'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../../assets/js/styles'
import PatrimonioOwnerHttp from '../../../../../services/api/https/patrimonio/patrimonio-owner.http'
import { showMessageBox } from '../../../../../store/actions/system.actions'
import { connect } from 'react-redux'

function ModalUsuarioPatrimonioOwner({ userId, show, onClose, dispatch }) {
  const [owners, setOwners] = useState([])
  const [globalFilter, setGlobalFilter] = useState('')
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    PatrimonioOwnerHttp.fetchAssocUserPatrimonioOwner(userId)
      .then(inComingOwners => {
        setOwners(inComingOwners)
        setIsLoading(false)
      })
      .catch(error => {
        dispatch(showMessageBox(null, error))
        setIsLoading(false)
      })
  }, [userId])

  // Events
  const onCheckboxChange = async owner => {
    setIsLoading(true)
    PatrimonioOwnerHttp.assocUserPatrimonioOwnerHandler(userId, owner.patrimonio_owner_id)
      .then(inComingOwners => {
        setOwners(inComingOwners)
        setIsLoading(false)
      })
      .catch(error => {
        dispatch(showMessageBox(null, error))
        setIsLoading(false)
      })
  }

  // Render
  return (
    <CustomModal
      onClose={() => onClose('showModalPatrimonioOwner')}
      header={'Associação - Patrimônio Owner'}
      width={600}
      isVisible={show}
    >
      <div className="p-grid">
        <div className="p-col-12">
          <DataTable
            loading={isLoading}
            value={owners}
            paginator={true}
            rows={5}
            header={<CustomDataTableHeader onChange={setGlobalFilter} />}
            globalFilter={globalFilter}
          >
            <Column
              header={'#'}
              body={owner => (
                <CustomCheckbox
                  checked={owner.assoc_id !== null}
                  onChange={() => onCheckboxChange(owner)}
                />
              )}
              style={tableCellCentered(80)}
            />
            <Column field={'patrimonio_owner_name'} header={'Patrimônio Owner'} />
          </DataTable>
        </div>
      </div>
    </CustomModal>
  )
}

export default connect()(ModalUsuarioPatrimonioOwner)
